// extracted by mini-css-extract-plugin
export default {"facebook":"oAZmza"};